import { connect } from 'react-redux';
import React from 'react';
import FormElement from 'components/FormElement';
import CyberComponent from 'containers/CyberComponent';
import { handleInputChange } from 'actions/request';
import { hasStringValue, getDeviceInfoPermission } from 'helpers/RequestHelper';
import { emptyMsg } from 'helpers/FormHelper';

class RequestSWVersion extends CyberComponent {
  state = { show: false, touched: false };

  componentDidMount() {
    this.setState({
      show: this.hasSwVersion()
    });
  }

  isValidationRequired = () => {
    return this.props.user.canEditRequest;
  };

  hasSwVersion() {
    const { app, request } = this.props;

    // check for cyber program
    if (app.isCyberCert) {
      return hasStringValue(request, 'swVersion');
    }

    // check for battery program
    if (app.isBatteryCert) {
      return true;
    }

    if (app.isBLCCert) {
      return true;
    }

    // check for OTA
    if (app.isOTACert) {
      return true;
    }

    return false;
  }

  validateSwVersion() {
    if (!this.isValidationRequired() || !this.state.touched) return null;

    return this.state.show && hasStringValue(this.props.request, 'swVersion')
      ? null
      : 'error';
  }

  onFieldChanged = event => {
    if (!this.state.touched) {
      this.setState({ touched: true});
    }
    
    this.props.handleInputChange(event);
  }

  render() {
    const { app, request, user } = this.props;
    const isEditable = getDeviceInfoPermission(app, user);
    const inputType = isEditable ? 'text' : '';

    return (
      <FormElement
        id="swVersion"
        label="SW Version"
        value={request.swVersion}
        show={this.state.show}
        editable={isEditable}
        type={inputType}
        onChange={this.onFieldChanged}
        validationState={this.validateSwVersion()}
        validationMessage={emptyMsg}
        maxLength={50}
      />
    );
  }
}

function mapStateToProps({ app, request, user }) {
  return { app, request, user };
}

export default connect(
  mapStateToProps,
  { handleInputChange }
)(RequestSWVersion);
